import React from 'react';
import VideoSingleLIstLoading from '../../Components/UiLoadingComponents/VideoSingleLIstLoading';
import SingleVideoList from './SingleVideoList';

const VideoLists = ({ data, loading }) => {
    let content = null
    if (loading) {
        content = [...new Array(5)].map((single, i) => <VideoSingleLIstLoading key={i}></VideoSingleLIstLoading>)
    }
    else {
        content = data?.map(single => <SingleVideoList key={single.id} id={single.id} {...single}></SingleVideoList>)
    }
    return (
        <>
            <div
                className="col-span-full lg:col-auto max-h-[570px] overflow-y-auto bg-secondary p-4 rounded-md border border-slate-50/10 divide-y divide-slate-600/30">

                {
                    content
                }


            </div>
        </>
    );
};

export default VideoLists;